import React, { useEffect, useState } from 'react';
import axios from '../axios';
import {
    Container,
    DetailsBtns,
    DetailsHeading,
    Flex,
    H1,
    HeadingLeft,
    ListHeading,
    SmallSpacing,
    Table,
    Td,
    Th,
    Tr
} from "../../styles";
import { Link } from 'react-router-dom';
import useAdminStatus from '../hooks/useAdminStatus';

const Home = () => {
    const [semesters, setSemesters] = useState([]);
    const { isAdmin } = useAdminStatus();

    useEffect(() => {
        axios.get('/semesters/')
            .then(response => {
                console.log("API Response:", response.data); // Log the response
                setSemesters(response.data);
            })
            .catch(error => console.error("There was an error fetching the semesters!", error));
    }, []);

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this class?")) {
            axios.delete(`/class/delete/${id}/`)
                .then(() => {
                    setSemesters(prevSemesters => prevSemesters.map(semester => ({
                        ...semester,
                        classes: semester.classes.filter(classItem => classItem.id !== id)
                    })));
                })
                .catch(error => {
                    console.error("There was an error deleting the class!", error);
                });
        }
    };

    if (!semesters.length) {
        return <div>Loading...</div>;
    }

    return (
        <Container>
            <ListHeading>
                <H1>Welcome to Unitec - School of Computing</H1>
            </ListHeading>
            {semesters.map(semester => (
                <div key={semester.id}>
                    <HeadingLeft>
                        <h2>Semester {semester.semester} - {semester.year}</h2>
                    </HeadingLeft>
                    <Table>
                        <Tr>
                            <Th>Class Name</Th>
                            <DetailsHeading>Class Number</DetailsHeading>
                            <DetailsHeading>Details</DetailsHeading>
                        </Tr>
                        {semester.classes && semester.classes.length > 0 ? (
                            semester.classes.map(classItem => (
                                <Tr key={classItem.id}>
                                    <Td>{classItem.course_details?.name || "N/A"}</Td>
                                    <DetailsBtns>{classItem.number}</DetailsBtns>
                                    <DetailsBtns>
                                        <Flex>
                                            <Link to={`/class/${classItem.id}`}>View</Link>
                                            {isAdmin && (
                                                <>
                                                    <SmallSpacing />
                                                    <Link to={`/class/update/${classItem.id}`}>Update</Link>
                                                    <SmallSpacing />
                                                    <Link to="#" onClick={() => handleDelete(classItem.id)}>Delete</Link>
                                                </>
                                            )}
                                        </Flex>
                                    </DetailsBtns>
                                </Tr>
                            ))
                        ) : (
                            <Tr>
                                <Td>No classes available for this semester.</Td>
                            </Tr>
                        )}
                    </Table>
                </div>
            ))}
        </Container>
    );
};

export default Home;
